import { create } from "zustand";

export const usePwaStore = create((set, get) => ({
  deferredPrompt: null,
  isStandalone: false,
  isIos: false,
  isInstalled: false,
  showIosModal: false,

  setDeferredPrompt: (prompt) => set({ deferredPrompt: prompt }),
  setShowIosModal: (show) => set({ showIosModal: show }),
  setIsStandalone: (val) => set({ isStandalone: val }),
  setIsIos: (val) => set({ isIos: val }),
  setIsInstalled: (val) => set({ isInstalled: val }),

  initPwaListeners: () => {
    if (typeof window === "undefined") return () => {};

    // 1. Check standalone mode
    const isStandalone =
      Boolean(window.navigator.standalone) ||
      window.matchMedia("(display-mode: standalone)").matches;

    // 2. Check iOS
    const ua = window.navigator.userAgent || "";
    const isIos = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;

    set({ isStandalone, isIos });

    // 3. Listen for beforeinstallprompt
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      set({ deferredPrompt: e });
    };

    // 4. Listen for appinstalled
    const handleAppInstalled = () => {
      set({ isInstalled: true, isStandalone: true, deferredPrompt: null });
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    window.addEventListener("appinstalled", handleAppInstalled);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  },

  promptInstall: async () => {
    const { isIos, deferredPrompt } = get();

    if (isIos) {
      set({ showIosModal: true });
      return { outcome: "ios_guided" };
    }

    if (!deferredPrompt) {
      // Fallback instruction for browsers where deferredPrompt isn't available yet
      set({ showIosModal: true });
      return { outcome: "manual_guided" };
    }

    try {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === "accepted") {
        set({ isInstalled: true, deferredPrompt: null });
      }
      return { outcome };
    } catch (err) {
      console.warn("PWA install error:", err);
      set({ showIosModal: true });
      return { outcome: "error" };
    }
  },
}));
